var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53022 3.59112C6.82311 3.29823 6.82311 2.82335 6.53022 2.53046C6.23732 2.23757 5.76245 2.23757 5.46956 2.53046L2.53022 5.4698C2.23732 5.76269 2.23732 6.23757 2.53022 6.53046C2.82311 6.82335 3.29798 6.82335 3.59088 6.53046L6.53022 3.59112ZM19.5 12.0001C19.5 16.1423 16.1421 19.5001 12 19.5001C7.85786 19.5001 4.5 16.1423 4.5 12.0001C4.5 7.85799 7.85786 4.50012 12 4.50012C16.1421 4.50012 19.5 7.85799 19.5 12.0001ZM21 12.0001C21 16.9707 16.9706 21.0001 12 21.0001C7.02944 21.0001 3 16.9707 3 12.0001C3 7.02956 7.02944 3.00012 12 3.00012C16.9706 3.00012 21 7.02956 21 12.0001ZM17.4698 2.53046C17.1769 2.82335 17.1769 3.29823 17.4698 3.59112L20.4091 6.53046C20.702 6.82335 21.1769 6.82335 21.4698 6.53046C21.7627 6.23757 21.7627 5.76269 21.4698 5.4698L18.5304 2.53046C18.2375 2.23757 17.7627 2.23757 17.4698 2.53046ZM12.75 9.00012C12.75 8.58591 12.4142 8.25012 12 8.25012C11.5858 8.25012 11.25 8.58591 11.25 9.00012V12.5001C11.25 12.7636 11.3882 13.0077 11.6141 13.1432L14.1141 14.6432C14.4693 14.8564 14.93 14.7412 15.1431 14.386C15.3562 14.0308 15.2411 13.5701 14.8859 13.357L12.75 12.0755V9.00012Z",
    fill: "#081B3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/Reminder.c33d5024c218708b5688fba76f29c3ec.svg";
export { ForwardRef as ReactComponent };